<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-switch
        v-model="menuSetting.isValidPriceTarget"
        label="価格"
        class="v-input--reverse"
      />
    </v-flex>
    <v-flex v-if="menuSetting.isValidPriceTarget" xs10 offset-xs1>
      <v-layout row>
        <v-flex xs1>
          <v-select
            :items="minMansionPrices"
            v-model.number="menuSetting.priceTarget.minPrice"
            :item-text="'name'"
            :item-value="'value'"
            dense
            style="padding-top: 0px;"
          />
        </v-flex>
        <v-flex align-self-center xs1>
          <p align="center">〜</p>
        </v-flex>
        <v-flex xs1>
          <v-select
            :items="maxMansionPrices"
            v-model.number="menuSetting.priceTarget.maxPrice"
            :item-text="'name'"
            :item-value="'value'"
            dense
            style="padding-top: 0px;"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CampaignModalPageMansionPrice',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    minMansionPrices() {
      return [
        { name: '0円', value: 0 },
        { name: '500万円', value: 500 },
        { name: '1000万円', value: 1000 },
        { name: '1500万円', value: 1500 },
        { name: '2000万円', value: 2000 },
        { name: '2500万円', value: 2500 },
        { name: '3000万円', value: 3000 },
        { name: '3500万円', value: 3500 },
        { name: '4000万円', value: 4000 },
        { name: '4500万円', value: 4500 },
        { name: '5000万円', value: 5000 },
        { name: '5500万円', value: 5500 },
        { name: '6000万円', value: 6000 },
        { name: '6500万円', value: 6500 },
        { name: '7000万円', value: 7000 },
        { name: '7500万円', value: 7500 },
        { name: '8000万円', value: 8000 },
        { name: '8500万円', value: 8500 },
        { name: '9000万円', value: 9000 },
        { name: '9500万円', value: 9500 },
        { name: '1億円', value: 100000 },
      ]
    },
    maxMansionPrices() {
      return [
        { name: '500万円', value: 500 },
        { name: '1000万円', value: 1000 },
        { name: '1500万円', value: 1500 },
        { name: '2000万円', value: 2000 },
        { name: '2500万円', value: 2500 },
        { name: '3000万円', value: 3000 },
        { name: '3500万円', value: 3500 },
        { name: '4000万円', value: 4000 },
        { name: '4500万円', value: 4500 },
        { name: '5000万円', value: 5000 },
        { name: '5500万円', value: 5500 },
        { name: '6000万円', value: 6000 },
        { name: '6500万円', value: 6500 },
        { name: '7000万円', value: 7000 },
        { name: '7500万円', value: 7500 },
        { name: '8000万円', value: 8000 },
        { name: '8500万円', value: 8500 },
        { name: '9000万円', value: 9000 },
        { name: '9500万円', value: 9500 },
        { name: '1億円', value: 100000 },
        { name: '指定しない', value: null },
      ]
    },
  },
  methods: {
    validate() {
      if (!this.menuSetting.isValidPriceTarget) {
        return true
      }
      const priceTarget = this.menuSetting.priceTarget
      if (priceTarget.maxPrice === null) {
        return true
      }
      return priceTarget.minPrice <= priceTarget.maxPrice
    },
  },
}
</script>

<style scoped lang="scss">
.v-input--reverse {
  ::v-deep .v-input__slot {
    flex-direction: row-reverse;
    .v-input--selection-controls__input {
      margin-left: 8px;
    }
  }
}
</style>
